<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              :isRequiredFarms="true"
              :filterOfLots="false"
              classFarms="`col-12 col-sm-12 col-md-4 col-lg-6 col-xl-6`"
            >
              <template slot="after-lot">
                <select-component
                  class="pt-3"
                  :rowClass="`col-12 col-sm-6 col-md-4 col-lg-3 col-xl-6`"
                  :labelSelect="`${$t('common_words.module2')}: *`"
                  :dataOptions="modules"
                  :requireClass="`required-modules`"
                  :initialSelection="dataFilter.modules"
                  @onChange="handleChangeSelected"
                  modelName="modules"
                />
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>
    <div class="col-12">
      <div v-if="tableData.length > 0">
        <card class="custom-shadow-card-header custom-table-responsive">
          <div v-if="isIndex()">
            <card-header
              :propPagination="pagination"
              @searchedQuery="searchedQuery"
              class="mr-3 mt-4"
            ></card-header>
            <master-table :infoTable="queriedData" :columns="tableColumns">
              <template slot="addColumnsOperations">
                <table-columns-operations
                  v-if="isShow()"
                  @handleView="handleView"
                  :showOperationEdit="false"
                  :canDisable="false"
                  :canDelete="false"
                  :minWidth="100"
                />
              </template>
            </master-table>
          </div>
          <not-index-permissions v-else />
          <card-footer ref="cardfooter" :propPagination="pagination" />
          <export-tables
            :pdf="{
              filename: 'SummaryAuditsReport.pdf',
              route: 'summary/auditsreport/pdf',
              paramMethod: 'POST',
              plusData: { ...exportData },
            }"
            :xls="{
              filename: 'SummaryAuditsReport.xlsx',
              route: 'summary/auditsreport/excel',
              paramMethod: 'POST',
              plusData: { ...exportData },
            }"
          />
          <br />
        </card>
        <el-dialog
          v-if="isShow()"
          :title="$t('common_words.record_selected_threepoints')"
          :visible.sync="modals.read"
          width="50%"
          top="2%"
        >
          <p>
            {{ $t('common_words.selected_record_info') }}
          </p>
          <div class="card" v-if="rowData">
            <div class="card-body">
              <table-details :data="rowData" />
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import AsideList from 'src/components/Layouts/AsideList.vue';
import configTable from './ReportTable';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import TableDetails from './TableDetails.vue';

export default {
  components: {
    [AsideList.name]: AsideList,
    [Filter.name]: Filter,
    [TableDetails.name]: TableDetails,
  },

  computed: {
    ...configTable().Search,
    exportData() {
      const response = { data: { ...this.tableData } };
      delete response.route;

      return response;
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    modules() {
      return this.concatAll([
        { id: 1, name: i18n.t('production.baggd') },
        { id: 2, name: i18n.t('production.harvest') },
        { id: 3, name: i18n.t('production.ringings') },
        { id: 4, name: i18n.t('production.crafted_boxes') },
      ]);
    },
  },

  data() {
    return {
      pagination: {},
      tableColumns: [],
      valueCollapse: null,
      activeName: 'filter',
      dataFilter: {
        modules: [],
      },
    };
  },

  mixins: [MixinMasters, MixinMenu, MixinForm, MixinPermissions],
  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    handleChangeSelected(data) {
      this.$set(this.dataFilter, data.name, data.selects);
    },

    handleFilter(data) {
      if (!isset(this.dataFilter.modules)) {
        return this.validationInputsRequired('modules');
      } else {
        this.dataFilter = { ...this.dataFilter, ...data };
        this.getData();
      }
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleView(_, row) {
      this.rowData = {
        ...row,
      };
      this.modals['read'] = true;
    },

    getData() {
      this.showHideLoading(true);
      let data = this.dataFilter;

      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }
      data.route = 'summary/auditsreport';

      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.searchFuse(
              this.tableColumns.map((column) => {
                return column.prop;
              })
            );
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';

            this.updateDataPagination(
              'cardfooter',
              [this.from, this.to, this.total],
              5
            );
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    this.setupTable();
  },

  mounted() {
    this.selectedItemOnMenu('summary');
  },

  destroyed() {
    this.deselectedItemOnMenu('summary');
  },
};
</script>
